import { render, staticRenderFns } from "./BillableDetails.vue?vue&type=template&id=5c5173d9&scoped=true"
import script from "./BillableDetails.vue?vue&type=script&lang=js"
export * from "./BillableDetails.vue?vue&type=script&lang=js"
import style0 from "./BillableDetails.vue?vue&type=style&index=0&id=5c5173d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5173d9",
  null
  
)

export default component.exports